import Grid from '@mui/material/Grid';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { getAllServices } from '../../../../api/ListOfServicesPerCategory';
import { capitalizeFirstLetter } from '../../../../utilities/functions/StringUtil';
import {
    Title,
    FooterContainer,
    LinkText,
    FooterText,
    CenterContainer,
    TitleDivider
} from './styles/FooterStyles';

function Footer() {
    const history = useHistory();

    const { data: listOfServices,isLoading } = useQuery(['listOfServices'], () => getAllServices())
    if(isLoading) return null;
    return (
            <FooterContainer>
                <CenterContainer >
                    <Title>Directorio de trámites</Title>
                    <TitleDivider/>
                    {/* 
                    columns={{ xs: 4, sm: 8, md: 8 }}
            
                    */}
                    <Grid  container justifyContent="space-between" direction="row"   spacing={2} >
                        {
                            (Array.isArray(listOfServices) ? listOfServices : []).map((direction) => (
                                <Grid xs={12} sm={6} md={6} xl={6} item direction="column" key={direction.id}>
                                    <FooterText>{direction.name}</FooterText>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {
                                            (Array.isArray(direction.services) ? direction.services : []).map((service) => (
                                                <LinkText key={service.id} title={capitalizeFirstLetter(service.name)}
                                                onClick={() => history.push(`/app/serviceDescription/${service.id}`)}>
                                                {capitalizeFirstLetter(service.name)}</LinkText>
                                            ))
                                        }
                                    </div>
                                </Grid>
                            ))
                        }
                    </Grid>
                </CenterContainer>
            </FooterContainer>
    );
}

export default Footer;
